import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import { UserAuthConnection } from '@frontend/types';

const TOOLS_MANAGEMENT_URL = `${OPAL_URL}/tools-mgmt-service`;

export const getUserAuthConnections = (userId: string) => {
  const key = ['user-auth-connections', userId];
  return {
    key,
    queryFn: async () => {
      const response = await http.get<UserAuthConnection[]>(
        `${TOOLS_MANAGEMENT_URL}/api/auth/users/${userId}/credentials`
      );
      return response.data;
    },
  };
};

type InitiateAuthParams = {
  provider: string;
  scopeBundleId: string;
  userId: string;
  redirectUri: string;
};

export function initiateAuthConnection(params: InitiateAuthParams) {
  return http.post<{ auth_url: string }>(`${TOOLS_MANAGEMENT_URL}/api/auth/initiate`, {
    provider: params.provider,
    scope_bundle_id: params.scopeBundleId,
    user_id: params.userId,
    redirect_uri: params.redirectUri,
  });
}

export function revokeAuthConnection(userId: string, credentialId: string) {
  return http.post(`${TOOLS_MANAGEMENT_URL}/api/auth/revoke`, {
    user_id: userId,
    credential_id: credentialId,
  });
}
